import {
  FieldsEnum,
  FormsEnum,
  SectionsEnum,
  DictionariesEnum,
  RenewalChangedAddressEnum,
} from 'app/shared/enums';
import {
  zipCodeChange,
  bankZipCodeChange,
} from 'app/services/businessFunctions/helpers/zipCodeChange';
import {
  setupHomeAddressSectionVisibility,
  setupCheckutPaymentSuspendedHomeAddressSectionVisibility,
} from 'app/services/businessFunctions/helpers/setHomeAddressSectionVisibility';
import { showAddressFieldsForRenewal } from 'app/services/businessFunctions/helpers/showAddressFieldsForRenewal';

const ownerAddressDetails = {
  checkoutOwnerHomeAddressNotSameAsLegalChange() {
    setupHomeAddressSectionVisibility({
      homeAddressNotSameAsLegalQuestionKey:
        FieldsEnum.OwnerHomeAddressNotSameAsLegal,
      homeAddressSectionKey: SectionsEnum.CheckoutSectionCarOwnerHomeAddress,
    });
    setupHomeAddressSectionVisibility({
      homeAddressNotSameAsLegalQuestionKey:
        FieldsEnum.OwnerHomeAddressNotSameAsLegal,
      homeAddressSectionKey: SectionsEnum.CheckoutSectionCarOwnerHomeAddress2,
    });
  },
  checkoutPaymentSuspendedOwnerHomeAddressNotSameAsLegalChange() {
    setupCheckutPaymentSuspendedHomeAddressSectionVisibility({
      homeAddressNotSameAsLegalQuestionKey:
        FieldsEnum.OwnerHomeAddressNotSameAsLegal,
      homeAddressSectionKey: SectionsEnum.SuspendedPolicyOwnerHomeAddress,
    });
  },
  checkoutOwnerHomeAddressZipCodeChange(initialRun: boolean) {
    showAddressFieldsForRenewal(
      initialRun,
      RenewalChangedAddressEnum.OwnerHome
    );

    zipCodeChange(
      initialRun,
      FieldsEnum.OwnerHomeAddressZipCode,
      FormsEnum.CheckoutForm
    );
  },
  checkoutOwnerHomeAddressCityChange(initialRun: boolean) {
    showAddressFieldsForRenewal(
      initialRun,
      RenewalChangedAddressEnum.OwnerHome
    );
  },
  checkoutOwnerLegalAddressZipCodeChange(initialRun: boolean) {
    showAddressFieldsForRenewal(
      initialRun,
      RenewalChangedAddressEnum.OwnerLegal
    );

    zipCodeChange(
      initialRun,
      FieldsEnum.OwnerLegalAddressZipCode,
      FormsEnum.CheckoutForm
    );
  },
  checkoutOwnerLegalAddressCityChange(initialRun: boolean) {
    showAddressFieldsForRenewal(
      initialRun,
      RenewalChangedAddressEnum.OwnerLegal
    );
  },
  checkoutPaymentSuspendedOwnerLegalAddressZipCodeChange(initialRun: boolean) {
    zipCodeChange(
      initialRun,
      FieldsEnum.OwnerLegalAddressZipCode,
      FormsEnum.CheckoutPaymentAlertForm
    );
  },
  checkoutPaymentSuspendedOwnerHomeAddressZipCodeChange(initialRun: boolean) {
    zipCodeChange(
      initialRun,
      FieldsEnum.OwnerHomeAddressZipCode,
      FormsEnum.CheckoutPaymentAlertForm
    );
  },
  checkoutBankZipCodeChange(initialRun: boolean) {
    bankZipCodeChange(
      initialRun,
      FieldsEnum.BankZipCode,
      DictionariesEnum.PolicyCessionBanks,
      FormsEnum.CheckoutForm
    );
  },
  checkoutLink4BankZipCodeChange(initialRun: boolean) {
    bankZipCodeChange(
      initialRun,
      FieldsEnum.BankZipCode,
      DictionariesEnum.Link4PolicyCessionBanks,
      FormsEnum.CheckoutForm
    );
  },
};

export default ownerAddressDetails;
